import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { appNavigate } from '../utils/appNavigate';
import { navigateToJobWizardView } from '../utils/jobWizardViewProgress';

/**
 * Legacy `/wafer-transfer` route — forwards to the operations job wizard monitor.
 */
const WaferTransferRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const jobId = searchParams.get('jobId');
    if (jobId) {
      navigateToJobWizardView({ jobId, jobType: 'batch_wafer_transfer' });
      return;
    }
    appNavigate('/operations/jobs/new');
  }, [searchParams]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 6 }}>
      <CircularProgress />
    </Box>
  );
};

export default WaferTransferRedirect;
